import React from 'react'
import { InstantSearch, Configure, Index, InstantSearchSSRProvider } from 'react-instantsearch'
import { algoliaClient } from 'api/algolia'
import { config } from 'utils/config'
import { useCurrentUser } from 'modules/auth/useCurrentUser'

interface Props {
  children: React.ReactNode
}

const ALGOLIA_ENV = config.apiEnv

export const AlgoliaConfigProvider = ({ children }: Props) => {
  const { user } = useCurrentUser()

  return (
    <InstantSearchSSRProvider initialResults={{}}>
      <InstantSearch searchClient={algoliaClient} indexName={`brands_${ALGOLIA_ENV}`}>
        <Configure clickAnalytics userToken={user?.firebaseUid} hitsPerPage={3} />
        <Index indexName={`categories_${ALGOLIA_ENV}`} indexId="categories" />
        <Index indexName={`brands_${ALGOLIA_ENV}`} indexId="brands">
          <Configure filters="status:Published" />
        </Index>
        {children}
        {/* Do not search query suggestions for now to keep UI simple */}
        {/* <Index indexName={`brands_${ALGOLIA_ENV}_query_suggestions`} indexId="suggestions" /> */}
      </InstantSearch>
    </InstantSearchSSRProvider>
  )
}
